import moment from 'moment';

const getTimeDifference = (createdDate) => {
  // Parse createdDate string into a moment object in UTC
  const createdDateInUTC = moment.utc(createdDate, "YYYY-MM-DD HH:mm:ss");

  // Get current time in UTC
  const nowInUTC = moment.utc();

  // Calculate time difference in milliseconds
  const timeDifference = nowInUTC.diff(createdDateInUTC);

  // Calculate differences in time units
  const minutesDifference = Math.floor(timeDifference / (1000 * 60));
  const hoursDifference = Math.floor(minutesDifference / 60);
  const daysDifference = Math.floor(hoursDifference / 24);
  const monthsDifference = Math.floor(daysDifference / 30.44);

  if (minutesDifference < 1) {
    return " Just now";  // Handle case where it's within the first minute
  } else if (monthsDifference > 0) {
    return ` ${monthsDifference} month${monthsDifference > 1 ? "s" : ""} ago`;
  } else if (daysDifference > 0) {
    return ` ${daysDifference} day${daysDifference > 1 ? "s" : ""} ago`;
  } else if (hoursDifference > 0) {
    return ` ${hoursDifference} hour${hoursDifference > 1 ? "s" : ""} ago`;
  } else {
    return ` ${minutesDifference} minute${minutesDifference > 1 ? "s" : ""} ago`;
  }
};

export default getTimeDifference;
